import { motion } from "framer-motion";
import { Landmark, PieChart, Sparkles, AlertCircle } from "lucide-react";
import AuditField from "./AuditField";

export default function BlocPatrimoine({ data }) {
  const formatCurrency = (val) => {
    const num = Number(val);
    if (isNaN(num) || !val) return "0 €";
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(num);
  };

  return (
    <motion.section 
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="space-y-6"
    >
      <div className="workspace-card p-6 rounded-[var(--hp-radius-lg)] border border-workspace bg-surface shadow-hp-sm space-y-6">
        <div className="flex items-center gap-2.5 pb-3 border-b border-workspace">
          <Landmark className="w-5 h-5 text-secondary" />
          <div>
            <h2 className="text-lg font-bold text-primary">Patrimoine Global Consolidé</h2>
            <p className="text-xs text-subtle">Agrégation des actifs privés du foyer (IR) et des détentions d'entreprises (IS)</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3.5">
          <AuditField label="Patrimoine Financier (Épargne & Placements)" value={formatCurrency(data.patrimoineFinancier)} />
          <AuditField label="Patrimoine Immobilier Direct" value={formatCurrency(data.patrimoineImmobilier)} />
          <AuditField label="Patrimoine Professionnel (Titres & Holdings)" value={formatCurrency(data.patrimoineProfessionnel)} />
          <AuditField label="Autres Actifs & Objets d'Art" value={formatCurrency(data.patrimoineAutres)} />
          <AuditField 
            label="Endettement Global (Passif)" 
            value={formatCurrency(data.endettement || data.totalDettes)} 
            className="text-danger-700 font-semibold"
          />
          <AuditField 
            label="Patrimoine Net Consolidé" 
            value={formatCurrency(data.patrimoineNet)} 
            className="font-bold text-primary bg-[var(--hp-success-100)] border-[var(--hp-success-200)] text-success-800"
          />
        </div>

        {/* 🚀 Investissements Alternatifs (Hipparchus) */}
        <div className="pt-4 border-t border-workspace">
          <div className="flex items-center gap-2 mb-3">
            <Sparkles className="w-4 h-4 text-[var(--hp-color-accent-text)]" />
            <h3 className="text-sm font-bold text-primary">Opérations & Participations Non Cotées</h3>
          </div>

          {data.transactionParticipations && data.transactionParticipations.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
              {data.transactionParticipations.map((part, i) => (
                <div key={i} className="p-3.5 rounded-lg border border-workspace bg-surface-muted/30">
                  <p className="text-xs font-bold text-primary mb-1">{part.transaction?.title || "Opération Club Deal"}</p>
                  <div className="flex items-center justify-between text-xs text-subtle">
                    <span>Rôle : <strong>{part.role}</strong></span>
                    <span className="font-semibold text-primary">{formatCurrency(part.investedAmount || part.committedAmount || 0)}</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-xs text-subtle italic py-1">Aucun investissement alternatif direct en cours.</p>
          )}
        </div>
      </div>
    </motion.section>
  );
}
